// extracted by mini-css-extract-plugin
export default {"dashboardTable":"style_dashboardTable__QsZWe","link":"style_link__4JU8K","summaryItem":"style_summaryItem__ljRY3"};